// @flow

import React from "react";
import { localize } from "redux-i18n";

import { SchemaForm } from "@components";
import { uiSchema } from "./ui-schema";

type OwnProps = $Exact<{
  data: ?Object,
  schema: Object,
  onChange: Function,
  onSubmit: Function,
  editing: boolean,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export function RtwSettings({ data, editing, t, onChange, onSubmit, schema }: Props) {
  const formData = {
    ...data,
    managerCanChangeReason: false,
    eligibilityRule: "ALL_FULL_CONTACTS",
    creationRule: "ONE_PER_ABSENCE",
  };

  function handleChange(formData) {
    if (!formData.absenceTypeScope) formData.absenceTypeScope = "ALL";
    onChange(formData);
  }

  return (
    formData && (
      <SchemaForm
        formData={formData}
        schema={schema}
        onChange={handleChange}
        onSubmit={onSubmit}
        uiSchema={uiSchema(t, editing)}
        externalSubmit
        className="gs-container"
      />
    )
  );
}

export default localize()(RtwSettings);
